import React from 'react';

import { faUserTag } from '@fortawesome/pro-regular-svg-icons';
import { Link } from 'react-router-dom';

import ResourceList from '../components/ResourceList';
import clients from './clients';

export default {
  name: 'jointure_client_entite',
  title: 'Entités clientes',
  icon: faUserTag,
  resource: 'jointure_client_entite',
  primaryKey: 'jointure_client_entite_id',
  query: { _associations: 'client' },
  head: {
    type: 'Type',
    nom: 'Nom',
    prenom: 'Prénom',
    tel_dom: 'Téléphone',
    email: 'Email',
    adresse: 'Adresse',
    cp: 'Code postal',
    ville: 'Ville',
  },
  list: ({ values }) => [
    values.client?.civilite,
    <Link to={{ pathname: `/i9/clients/${values.client?.idClient}` }}>{values.client?.nom}</Link>,
    <Link to={{ pathname: `/i9/clients/${values.client?.idClient}` }}>{values.client?.prenom}</Link>,
    values.client?.tel_port,
    values.client?.email,
    values.client?.adresse,
    values.client?.cp,
    values.client?.ville,
  ],
  edit: ({ values, props, setFieldValue, handleSubmit }) => [
    <ResourceList
      {...clients}
      filters={{ idindividu: props.conseiller }}
      select={e => {
        if (e.length === 0) return;
        setFieldValue('idClient', e[0].idClient);
        handleSubmit();
      }}
    />,
  ],
  add: true,
  popup: true,
  remove: true,
};
